{
  "id": "action-presentation",
  "version": "0.1.0",
  "status": "candidate",
  "owner": "granular",
  "createdAt": "2026-05-25T00:00:00.000Z",
  "changelog": "Candidate harness template focused on action-request detection and mutation result presentation. It exists to harden cases where the model answers with a terse completion such as Done instead of using tools and reporting the target/action/result.",
  "promptBuilder": "buildGranularAgentSystemPrompt:action-presentation",
  "continuationBuilder": "buildContinuationInstruction:action-presentation",
  "modelOutputInstruction": "agent-evals:modelOutputInstruction",
  "codeReviewPolicy": "reviewGeneratedJobCode",
  "defaultModel": "gpt-5.6-luna",
  "modelMatrix": ["gpt-5.6-luna"],
  "temperature": 0,
  "compatibility": {
    "minSdkVersion": "0.4.40",
    "capabilities": [
      "executeCode",
      "readEntities",
      "workflowHelpers",
      "savedData",
      "showRecords"
    ]
  },
  "evalGates": {
    "requiredSuites": [
      "agent-harness-hardening",
      "agent-harness-runtime-e2e",
      "agent-production-readiness-e2e"
    ],
    "criticalBuckets": [
      "relationship-traversal",
      "cross-turn-reference",
      "ambiguous-target-choice",
      "confirmation-gated-mutation",
      "denied-action-refusal",
      "mutation-presentation"
    ],
    "maxRegressionPct": 0,
    "minPassK": {
      "critical-mutation": 0.9,
      "permission-boundary": 1
    }
  }
}
